import React, { useEffect } from 'react';
import DataTable from 'react-data-table-component';

import { useContext } from 'components/ResourceNotes/Context';

import columns from './columns';

export default function Index() {
  const { dispatch, actions, state } = useContext();

  useEffect(() => {
    actions.load(
      dispatch,
      state.resourceType,
      state.resourceId,
    );
  }, []);

  return (
    <div className="datatable-style">
      <DataTable
        title="Notes"
        columns={columns}
        data={state.notes ? state.notes : []}
        noDataComponent={(
          <div className="mt20">
            {state.notes === null
              ? 'Please, wait ...'
              : 'No matching records found'}
          </div>
        )}
      />
    </div>
  );
}
